<cap-file-upload #capFileUpload
                 [id]="field.key"
                 *ngIf="!to.readonly"
                 label=""
                 [attr.data-test]="'builder-' + field.key"
                 [multiple]="to?.multiple"
                 [accept]="to.availableExtensions"
                 [uploaderContent]="uploadContent"
                 (onFileChange)="handleFileChange($event)">
</cap-file-upload>

<!-- PREVIEW DOWNLOADED FILES SECTION -->
<div class="preview--section" [attr.data-test]="'builder-readonly-' + field.key">
  <cap-file-preview-list [files]="previewFiles" [showDelete]="true" (onDeleteClick)="removeFile($event)"></cap-file-preview-list>
</div>

<ng-template #uploadContent>
  <div class="upload">
    <i class="fas fa-cloud-upload-alt"></i>
    <p [innerHTML]="field?.name"></p>
    <span class="placeholder" *ngIf="field?.props?.label as placeholder">{{ 'file.upload.description' | translate }}</span>
  </div>
</ng-template>
<cpb-readonly-container [hidden]="!(to?.readonly && previewFiles.length < 1)">
  {{ 'builders.no_preview_available.label' | translate }}
</cpb-readonly-container>
